<script lang="ts">
	import type { Snippet } from 'svelte';

	let {
		delay = 0,
		duration = 800,
		class: className = '',
		children,
		...restProps
	}: {
		delay?: number;
		duration?: number;
		class?: string;
		children?: Snippet;
		[key: string]: any;
	} = $props();
</script>

<div
	class="fade-in-3d {className}"
	style="
		animation-delay: {delay}ms;
		animation-duration: {duration}ms;
	"
	{...restProps}
>
	{@render children?.()}
</div>

<style>
	.fade-in-3d {
		opacity: 0;
		transform: perspective(4000px) rotateX(10deg) translateY(30px) translateZ(-200px);
		animation: fadeIn3D forwards;
		animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
		will-change: transform, opacity;
	}

	@keyframes fadeIn3D {
		to {
			opacity: 1;
			transform: perspective(4000px) rotateX(0deg) translateY(0px) translateZ(0px);
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.fade-in-3d {
			transform: none;
			animation: simpleFadeIn forwards;
		}

		@keyframes simpleFadeIn {
			to {
				opacity: 1;
			}
		}
	}
</style>
